import App from 'packages/main/application';
import { ENV, GIT_SHA } from 'packages/env';
import * as Sentry from '@sentry/react';
import * as serviceWorkerRegistration from 'packages/main/serviceWorkerRegistration';
import { redirectToLogin } from 'packages/lib/auth';
import { ResponseNotOk } from 'packages/lib/utils/error';
import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
if (!container) {
  throw new Error('App root container not found in DOM. Cannot mount <App />');
}
const root = createRoot(container);

const ENABLE_SENTRY = false;
if (ENABLE_SENTRY) {
  Sentry.init({
    dsn: 'https://bcae4720192d4bd4b6c620987be8e861@o458014.ingest.sentry.io/5495406',
    integrations: [],
    sampleRate: 0.01,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    release: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG?.release ?? GIT_SHA,
    dist: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG?.dist ?? GIT_SHA,
    environment: ENV,
    attachStacktrace: true,
    beforeSend: (e, { originalException: ex }) => {
      // quiet auth induced errors, trigger login
      if (
        ex instanceof ResponseNotOk &&
        (ex.response.status === 401 || ex.response.status === 403)
      ) {
        void redirectToLogin();
        return null;
      }
      return e;
    },
  });
}

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister();
